import React, { useContext, useEffect, useState } from 'react';
import { Cell, PieChart, Pie, BarChart, Line, ComposedChart, Bar, ResponsiveContainer, Legend, LabelList, Brush, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import { MyContext } from './MyContext';
import * as datafetcher from './ContextDataFetcher'
import { colors } from './DownTimeTotals';
import parse from 'date-fns/parse'
import useGraphLegend from './useGraphLegend';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import { useHistory } from 'react-router-dom'; //when updating to v6 then useNavigate will be used
import Typography from '@material-ui/core/Typography';
import DowntimeTable from './DowntimeTable';


const AnalyticsDowntime = () => {
    const { customerName, downtimeReport, setDowntimeReport, dialogReasonCodes, selectedMachines, setArchiveDate } = useContext(MyContext);
    const [txDowntime, setTxDowntime] = useState([]);
    const [shiftOneDowntime, setShiftOneDowntime] = useState([]);
    const [shiftTwoDowntime, setShiftTwoDowntime] = useState([]);
    const [shiftThreeDowntime, setShiftThreeDowntime] = useState([]);
    const { showHideBar, handleLegendClick } = useGraphLegend(); //this contains the bars that are hidden
    const [showStacked, setShowStacked] = useState(false);
    const [shiftName, setShiftName] = useState(["shift1"]);
    const [chartDowntimeTotals, setChartDowntimeTotals] = useState([])
    const [viewedStartDate, setViewedStartDate] = useState()
    const [viewedEndDate, setViewEndDate] = useState()
    let navigate = useHistory();


   
    useEffect(() => {
        if (customerName && !downtimeReport) {
            datafetcher.getDowntimeReport(customerName, setDowntimeReport);
        }
    }, [customerName]);
    useEffect(() => {
        if (downtimeReport && dialogReasonCodes) {
            //transform this data
            var newtxdowntime = [];
            var shiftonedowntime = [];
            var shifttwodowntime = [];
            var shiftthreedowntime = [];
            (downtimeReport).forEach(element => {
                var downTimeTotals = getDowntimesByReasoncode(element);
                // var dateshift = element.date + '_' + element.shift;
                var aDate = parse(element.date, "M-d-yyyy", new Date())
                // var lastIndex = element.date.lastIndexOf("-");
                //var strDate = element.date.slice(0,lastIndex);
                var strDate = element.date.replaceAll("-", "/");
                //newtxdowntime.push({ date: element.date, totals: downTimeTotals, datetimeseconds: element.datetimeseconds });
                if ("shift1" == element.shift) {
                    shiftonedowntime.push({ date: strDate, totals: downTimeTotals, datetimeseconds: element.datetimeseconds });
                }
                if ("shift2" == element.shift) {
                    shifttwodowntime.push({ date: strDate, totals: downTimeTotals, datetimeseconds: element.datetimeseconds });
                }
                if ("shift3" == element.shift) {
                    shiftthreedowntime.push({ date: strDate, totals: downTimeTotals, datetimeseconds: element.datetimeseconds });
                }

            });
            shiftonedowntime.sort((a, b) => (a.datetimeseconds > b.datetimeseconds) ? 1 : -1);
            shifttwodowntime.sort((a, b) => (a.datetimeseconds > b.datetimeseconds) ? 1 : -1);
            shiftthreedowntime.sort((a, b) => (a.datetimeseconds > b.datetimeseconds) ? 1 : -1);
            setShiftOneDowntime(shiftonedowntime);
            setShiftTwoDowntime(shifttwodowntime);
            setShiftThreeDowntime(shiftthreedowntime);
            //init to shiftone report
            setTxDowntime(shiftonedowntime);
            setViewEndDate(shiftonedowntime[shiftonedowntime.length-1].date)
            setViewedStartDate(shiftonedowntime[0].date)
        }
    }, [downtimeReport, dialogReasonCodes, selectedMachines]);

    useEffect(() => {
        calculateDowntimeTotals(txDowntime);

    }, [txDowntime, showHideBar])

    const calculateDowntimeTotals =(downtimeValues)=> {
        //downtimeValues[]: {date:'M/D/Y', totals:[{reasonCode:totalHours}], datetimeseconds:int}
        //the 0 elemenent in totals is the unlabeled total.  We skip that for this aggregate collection
        if (downtimeValues && downtimeValues.length > 0) {
            let dtTotals = new Array(dialogReasonCodes.length + 1).fill(0);  //add 1 b/c the 0 index is the unlabeled category
            downtimeValues.forEach(dateElement => {
                //for each date being displayed we'll keep a total of the individual downtime reason codes
                for (var i = 0; i < dateElement.totals.length; i++) {
                    //var reasonCode = dialogReasonCodes.find(elem => elem.id == i)
                    // console.log("adding index " + i + ' ' + reasonCode.name + ' ' + dateElement.date + ' value ' + dateElement.totals[i] + ' to total ' + dtTotals[i - 1])
                    //we need to fill the index if we do not have it.
                    dtTotals[i] = dtTotals[i] ? dtTotals[i] : 0
                    dtTotals[i] += dateElement.totals[i] ? dateElement.totals[i] : 0;
                }

            });
            var charTotals = [];
            //skip 0 b/c it's the unlabeled category we do not show
            //TODO: maybe we should show it.
            for (var i = 1; i < dtTotals.length; i++) {
                var reasonCode = dialogReasonCodes.find(code=>code.id==i)
                //There is the rare case we eliminated an downtime reasoncode and it's no longer used
                //but we have historical data associated to it. So we need to include it yet we don't have a 
                //reasonCode name for it.  Use NA + index
                //reasonCode = reasonCode ? reasonCode : {name:'NA' + i}
                if (reasonCode)
                {
                    //check if the legend excludes this reason code.  The showHidBar[] contains
                    //the elements that are excluded.  
                    if (showHideBar.indexOf('totals[' + reasonCode.id + ']') == -1)
                    {
                    charTotals.push({ name: reasonCode.name, value: Math.round(dtTotals[i]*10)/10, reasonCodeId:reasonCode.id });
                    }
                }
            }
            setChartDowntimeTotals(charTotals);
        }
    }
    //this takes a DowntimeData object and returns an ordered list of downtime values in
    //order of the columnListHeadings.
    const getDowntimesByReasoncode = (dateDowntime) => {
        //dateDowntime :{date:"", datetimeseconds:int, dayofweek:int, shift:"", totaldowntimemins:"", machinelist[{reasonCode:mins}]}
    
        //for each machine we'll look at their downtimes and how much time associated w/ each.
        //they get totaled up based on reasoncode
        let downtimeTotals = new Array(dialogReasonCodes.length+1).fill(0);
        //init the unlabeled category.  unlabeled is at the 0 index and average is the last index
        downtimeTotals[0] = 0;
        downtimeTotals[dialogReasonCodes.length - 1] = 0;
        if (dateDowntime.totaldowntimemins) {
            //since we have a total for this date/shift we'll add the value
            // console.log("downtime totaldowntimemins: " + downtime.totaldowntimemins);
            //add the unlabeled to the first category

            //we will store this in minutes so we can subtract from it more 
            //accurately and convert it to hours at the end of processing
            //each labeled reason code
            downtimeTotals[0] = parseInt(dateDowntime.totaldowntimemins);
        }

        for (let machineName in dateDowntime.machinelist) {
            var includedMachineDowntime = true;
            //09012019 if the machine is not selected from the machine selector then we don't
            //want to include it's down time in each of the individual buckets of 
            //labeled down time.  But since the totaldowntimemins does include
            //the unselected machines contribution then we still want to subtract
            //it's portion from the total.
            if (selectedMachines.indexOf(machineName) == -1) {
                includedMachineDowntime = false;
            }
            for (let reasonCodeNum in dateDowntime.machinelist[machineName]) {

                var total = Number(dateDowntime.machinelist[machineName][reasonCodeNum]);
                //3/12/2019 since we moved to AWS our python numbers have been 
                //converted to decimals instead of integers.  So we need to 
                //convert them back here so we don't have dict keys of 4.0 when
                //we want 4.  But it's important we do this conversion after
                //getting the total.
                // dtKey=parseInt(dtKey).toString();
                if (!downtimeTotals[reasonCodeNum]) {
                    //need to init this array position to zero otherwise it's NAN and you can't += it
                    downtimeTotals[reasonCodeNum] = 0;
                }
                if (includedMachineDowntime) {
                    var downTimeInHrs = (total / 60.0);
                    downtimeTotals[reasonCodeNum] += downTimeInHrs;
                }
                //subract from the unlabeled category
                if (downtimeTotals[0] > 0) {
                    //console.log("downtimeTotals[unlabeledIndex] subtracting: " + total + " for key: " + this.columnHeadings[dtKey] + " from: " + downtimeTotals[unlabeledIndex] );
                    downtimeTotals[0] -= total;
                    //console.log("downtimeTotals[unlabeledIndex] new value: " + downtimeTotals[unlabeledIndex] );
                }
                //console.log("DowntimereportingComponent.addDateDownTime dtKey: " + reasonCodeNum + " total: " + total);
            }
        }

        //round each value for presentation
        (downtimeTotals).map((element, index) => {
            downtimeTotals[index] = Math.round(element * 10) / 10;
        })
        //convert our unlabeled category to hrse
        var totalInHrs = downtimeTotals[0] / 60.0;
        //b/c of when down time gets calculated compared to the final report
        //we might be off in total hours of data captured which has let to some negative
        //number for unlabled.  So let's not display negative
        totalInHrs = Math.max(0, totalInHrs);
        totalInHrs = Math.round(totalInHrs * 10) / 10;
        downtimeTotals[0] = totalInHrs;
        return downtimeTotals;

    }

    const handleShiftChange = (event) => {

        //we have switched to using checkboxes so we can show more than 1 shift at a time.
        //We keep track of which checkboxes are checked with an array, shiftName[]
        //Events only come when a checkbox is checked or unchecked.  We update shiftName[] accordingly
        var selectedShift = event.target.value;
        var checked = event.target.checked;
        console.log(" AnalyticsDowntime handleShiftChange event: " + event.target.value + " checked: " + checked);
        var newShiftDowntime = []
        //copy the current selection []
        var newShiftName = shiftName.slice();
        //remove or add the shift the user just clicked on
        checked ? newShiftName.push(selectedShift) : newShiftName = newShiftName.filter(item => item != selectedShift)



        newShiftName.forEach(shiftName => {
            console.log("shifts viewed: " + shiftName)
            //use json serialization so we use a copy of the original data and not modify it.
            if (shiftName == "shift1") {
                newShiftDowntime.push(JSON.parse(JSON.stringify(shiftOneDowntime)))
            }
            if (shiftName == "shift2") {
                newShiftDowntime.push(JSON.parse(JSON.stringify(shiftTwoDowntime)))
            }
            if (shiftName == "shift3") {
                newShiftDowntime.push(JSON.parse(JSON.stringify(shiftThreeDowntime)))
            }
        })

        //newShiftDowntime is an [] that contains the 1, 2, or 3 shifts.
        //we will combine these elements

        var combinedDownTime = newShiftDowntime.length > 0 ? newShiftDowntime.reduce(combineDownTime) : []
        // var combinedDownTime = combineDownTime(shiftOneDowntime, shiftTwoDowntime)
        setTxDowntime(combinedDownTime);
        //  calcChartDowntimeTotals(combinedDownTime);
        //setShiftName(selectedShift);
        setShiftName(newShiftName);
    };



    const combineDownTime = (arrayOne, arrayTwo) => {
        //each array is a collection of objects {date, totals[], datetime}
        //if the 2 arrays have the same date then we combine the values in the total[].
        //The index of the total[] corresponds to a downTime Reason code ID
        var combined = []

        arrayTwo.forEach((elemTwo) => {
            //search for matching date
            var foundDate = arrayOne.find(element => element.date == elemTwo.date);
            if (foundDate) {
                //console.log('foundDate: ' + foundDate.date)
                //combine the reasoncode times
                for (var i = 0; i < foundDate.totals.length; i++) {
                    //the index of each array match the downtime reasoncode id
                    foundDate.totals[i] += elemTwo.totals[i]
                }
                combined.push(foundDate)
            }
            else {
                //console.log('adding but not foundDate: ' + elemTwo.date)
                //if we did not find a matching element in array one then we still add
                //the array two element to our combined []
                combined.push(elemTwo)
            }
        })
        return combined

    }

    const handleBarClick = (val, shiftName) => {
        //console.log("handleBarClick val: " + val.date + " shiftName: " + shiftName[0]);
        setArchiveDate({ date: parse(val.date, "M/d/yyyy", new Date()), shiftName: shiftName[0] });
        navigate.push('/start/' + customerName + '/downtimetotals');
    }

   
    const MyCustomBar = (props) => {
        const { stroke, fill, x, y, width, height, machinelist } = props;

        {

            return <rect
                x={x}
                y={y}
                width={width}
                height={height}
                stroke={stroke}
                fill={fill}
            />

        }
    };

   
    const handleBrushOnChange = (index) => {
        //console.log("Brush onChange index: " + index.startIndex + " end index " + index.endIndex);
        var viewedDowntime = txDowntime.slice(index.startIndex, index.endIndex + 1);
        setViewedStartDate(txDowntime[index.startIndex].date)
        setViewEndDate(txDowntime[index.endIndex].date)
        calculateDowntimeTotals(viewedDowntime)
    }

    
    return (

        <div>

            <div style={{ marginTop: '2px', marginLeft: '1px', display: 'flex' }}>

                <Typography variant="subtitle2" align="center" >
                    <Checkbox
                        value="shift1"
                        checked={shiftName.includes('shift1')}
                        name="shiftRadio"
                        onChange={handleShiftChange} />
                    Shift 1
                    <Checkbox
                        value="shift2"
                        checked={shiftName.includes('shift2')}
                        name="shiftRadio"
                        onChange={handleShiftChange} />
                    Shift 2
                    <Checkbox
                        value="shift3"
                        checked={shiftName.includes('shift3')}
                        name="shiftRadio"
                        onChange={handleShiftChange} />
                    Shift 3
                </Typography>

                <div style={{ position: 'absolute', right: '0px' }}>
                    Stacked Bar<Checkbox style={{ width: 30 }} checked={showStacked} onChange={() => { setShowStacked(!showStacked) }} />
                </div>

            </div>
            <ResponsiveContainer width={"100%"} height={300} >
                <ComposedChart
                    data={txDowntime}

                    margin={{
                        top: 10, right: 30, left: 0, bottom: 0,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip offset={30} />
                    <Legend onClick={handleLegendClick} />
                    {dialogReasonCodes?.map((item, i) => {
                        return (<Bar  shape={<MyCustomBar />} barSize={showStacked ? 5 : 150} name={item.name} hide={showHideBar.indexOf(`totals[${item.id}]`) !== -1} stackId={showStacked ? "stack" : { i }} dataKey={`totals[${item.id}]`} stroke={colors[item.id]} fill={colors[item.id]} onClick={(event) => { handleBarClick(event, shiftName) }} />)
                    })}
                    {/* <Bar type="monotone" dataKey="totaldowntimemins"  value={()=>{calcValue()}} shape={<MyCustomBar/>}  stroke="#8884d8" fill="#8884d8" ></Bar> */}



                    <Brush onChange={handleBrushOnChange} />

                </ComposedChart>


            </ResponsiveContainer>
           
            <div style={{ position: 'absolute', left: '20%' }}>
                <div style={{ position: 'absolute', right: '-40%', top:'10%' }}>
            <DowntimeTable selectedShifts={shiftName} startDate={viewedStartDate} endDate={viewedEndDate} selectedReasonCodes={showHideBar?showHideBar : []}></DowntimeTable>
            </div>
                <PieChart width={1000} height={500}>
                    <Pie
                    isAnimationActive={false} //set to false b/c there is a bug when true that the customLabel code doesn't get called
                        dataKey="value"
                        data={chartDowntimeTotals}
                        cx="50%"
                        cy="50%"
                        labelLine={true}
                        // label={renderCustomizedLabel}
                        //label
                        outerRadius={160}
                        fill="#8884d8"
                        label={({cx,cy,midAngle,innerRadius,outerRadius,percent,index}) => {
                            const RADIAN = Math.PI / 180;
                            const radius = 25 + innerRadius + (outerRadius - innerRadius);
                            const x = cx + radius * Math.cos(-midAngle * RADIAN);
                            const y = cy + radius * Math.sin(-midAngle * RADIAN);
                           
                            const perradius = innerRadius + (outerRadius - innerRadius) * 0.5;
                            const perx = cx + perradius * Math.cos(-midAngle * RADIAN);
                            const pery = cy + perradius * Math.sin(-midAngle * RADIAN);
                            return (<text x={x} y={y} fill="#000000" textAnchor={x > cx ? "start" : "end"} dominantBaseline="central">
                                <tspan >{chartDowntimeTotals[index].value}hrs - {chartDowntimeTotals[index].name}</tspan>
                                <tspan x={perx} y={pery} fill="white">
                                {`${(percent * 100).toFixed(0)}%`}
                                </tspan>
                              </text>);
                        }}
                    >
                        {chartDowntimeTotals.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={colors[entry.reasonCodeId]} />
                        ))}
                    </Pie>
                </PieChart>
            </div>
        </div>

    );
}
export default AnalyticsDowntime;